export function scheduleError(error) {
  const response = error && error.response;
  const message = response && response.data && response.data.errorSchema && response.data.errorSchema.errorMessage;
  if (typeof message === 'string' && message.trim()) return message;
  if (!response) return 'Tidak dapat terhubung ke server. Periksa koneksi, lalu coba simpan lagi.';
  if (response.status === 401) return 'Sesi berakhir. Silakan masuk kembali.';
  if (response.status === 403) return 'Jadwal berada di luar kewenangan akun ini.';
  if (response.status === 400) return 'Isian jadwal tidak sesuai. Periksa kelas, lingkup, dan tanggal jadwal.';
  return 'Jadwal belum berhasil diproses. Silakan coba lagi.';
}
